<template>
<div class="container">
  <form>
    <div class="names">
      <input type="text" v-model="lastName" placeholder="your last name">
      <input type="text" v-model="firstName" placeholder="your first name">
    </div>
    <input type="email" v-model="email" placeholder="email" required>
    <input type="text" v-model="message" placeholder="your message" required class="message">
    <button @click="sendEmail()">Submit</button>
    <div v-if="showMessage">
      <h1>I was too lazy to code the backend for this (please forgive me)</h1>
      <h3>If you really want to send me an email : <span class="important">julienlb49@gmail.com</span></h3>
    </div>
  </form>
</div>
</template>

<script>
export default {
  name: "EmailComponent",
  data(){
    return{
      lastName:"",
      firstName:"",
      email:"",
      message:"",
      showMessage:false,
    }
  },
  methods:{
    sendEmail(){
      console.log("hello world")
      this.showMessage = true
    }
  }
}
</script>

<style scoped>

*{
  margin: 0;
  padding:0;
  text-align: center;
}
input[type=text], input[type=email]{
  color: red;
  display: block;
  align-content: center;
  border-radius: 10px;
  padding: 10px 0px;
  margin: 10px auto;
  box-shadow: #2c3e50;
}
button{
  padding: 20px;
  background-color: wheat;
  color: darkgoldenrod;
  border-radius: 20px;
  width: 20%;
  font-weight: bold;
  box-shadow: #2c3e50;
}
h1{
  color:red;
}
h3{
  color: wheat;
}
.important{
  color: darkgoldenrod;
}
</style>